import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import CelebrateEmoji from 'assets/svg/celebrate_emoji.svg';
import HandsEmoji from 'assets/svg/hands_emoji.svg';
import HeartEmoji from 'assets/svg/heart_emoji.svg';
import ThumbsUpEmoji from 'assets/svg/thumbsup_emoji.svg';
import React from 'react';

export const EMOJIES = [
  { img: ThumbsUpEmoji, value: 'thumbs_up' },
  { img: HeartEmoji, value: 'heart' },
  { img: CelebrateEmoji, value: 'party' },
  { img: HandsEmoji, value: 'folded_hands' },
];

const StyledEmoji = styled('img')`
  height: 20px;
  width: 20px;
  margin-right: 20px;
  cursor: pointer;
`;

const Reactions = ({ message, onReaction }) => {
  if (message.is_message_reaction_enabled === '1') {
    return (
      <Box display="flex" justifyContent="flex-end" mt={2}>
        {EMOJIES.map((emoji, index) => (
          <StyledEmoji
            key={index}
            onClick={() => onReaction(emoji.value)}
            style={{ height: '20px' }}
            src={emoji.img}
            alt={emoji.value}
          />
        ))}
      </Box>
    );
  }
  return null;
};

export default Reactions;
